import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { EntityFormSchemaValues } from 'src/features/entity/formSchema';
import { Entity, ENTITY_TYPE } from 'src/features/entity/types';

const RESOURCE = `sp-core/:parkingId/entities/entity/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends EntityFormSchemaValues {
    parkingId: string;
    type: ENTITY_TYPE;
    id: string;
}
const mutationFn = ({ id, parkingId, ...data }: DTO): Promise<Entity> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateEntity };
